<template>
  <v-dialog v-model="dialog" persistent max-width="700">
    <v-card>
      <v-card-title class="headline">
        Change status for {{ numberOfRows }} row(s)?
      </v-card-title>
      <v-card-text>
        By this action you will change status for all rows with selected
        filters. (statuses filter/tabs). Do you really want to make this
        changes?
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="error" text @click="close">Disagree</v-btn>
        <v-btn color="primary" text @click="agree">Agree</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialog: false,
      status: undefined,
      numberOfRows: 0
    };
  },
  methods: {
    open(status, numberOfRows) {
      this.numberOfRows = numberOfRows;
      this.status = status;
      this.dialog = true;
    },
    close() {
      this.dialog = false;
    },
    agree() {
      this.$emit('onAgree', this.status);
      this.close();
    }
  }
};
</script>
